import { NAVIGATION_ITEMS, ROUTES } from ".";

const hiddenNavItems: NAVIGATION_ITEMS[] = [
  NAVIGATION_ITEMS.Dashboard,
  NAVIGATION_ITEMS.Integrations,
];

export const isItemVisible = (
  item: NAVIGATION_ITEMS,
  isAllowedToSeeItem: boolean = false
) => {
  if (hiddenNavItems.includes(item)) {
    return isAllowedToSeeItem; // by default hidden items are not visible except if the user role has access to them
  }
  return true;
};

export type LayoutType = {
  key: NAVIGATION_ITEMS;
  title: NAVIGATION_ITEMS;
  pathname: ROUTES;
  shouldBeVisible: boolean;
};
